import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Auto-detect POS devices at the site root and route them straight into the
 * POS shell. Detection = presence of `window.AndroidPrinter` (only injected
 * by our native WebView wrapper). Regular browsers pass straight through
 * and see the normal customer HomePage.
 *
 * We deliberately gate on the bridge, NOT on user-agent — a browser opened
 * on the POS device for troubleshooting still shows the customer app.
 */
export const RootRedirect = ({ children }) => {
  if (typeof window !== 'undefined' && window.AndroidPrinter) {
    return <Navigate to="/pos" replace />;
  }
  return children;
};

export default RootRedirect;
